export default {
  namespaced: true,
  state: {
    showEditModal: false
  },
  mutations: {
    UPDATE_SHOW_EDIT_MODAL(state, payload) {
      state.showEditModal = payload;
    }
  },
  actions: {}
};
